/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ModuleAccessWithRelations } from './moduleAccessWithRelations';
import { ModuleWithRelations } from './moduleWithRelations';


/**
 * (tsType: ModulePermissionWithRelations, schemaOptions: { includeRelations: true })
 */
export interface ModulePermissionWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    permissions?: Array<string>;
    moduleId?: string;
    module?: ModuleWithRelations;
    moduleAccesses?: Array<ModuleAccessWithRelations>;
}

